import { render } from "./ValidationObserver.vue?vue&type=template&id=f8807f9a&ts=true"
import script from "./ValidationObserver.vue?vue&type=script&lang=ts"
export * from "./ValidationObserver.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__